// @ts-nocheck
import React from 'react';
import { Tooltip, Button } from 'antd';
import { useSpring, animated, interpolate } from '@react-spring/web';
import { useGesture } from 'react-with-gesture';

import './ActionButton.sass';

export const ActionButton = (props: any) => {
	const [bind, { down }] = useGesture();
	const { x, size } = useSpring({
		size: down ? 1.1 : 1,
		immediate: (name: string) => down && name === 'x'
	});

	const body = (
		<Button className="ActionButton" shape="circle" size="small" icon={props.icon} style={props.style}>

			{props.popover ? (
				React.cloneElement(props.popover, {
					children: (
						<div
							onClick={props.onClick}

						>
							{props.children}
						</div>
					)
				})
			) : (
				<div onClick={props.onClick} className="ActionButton">
					{props.children}
				</div>
			)}

		</Button>
	);

	return props.tooltip ? (
		<Tooltip title={props.tooltip}>{body}</Tooltip>
	) : (
		body
	);
};

export default ActionButton;
